<!-- eslint-disable eqeqeq -->
<template>
  <div id="app">
    <!-- <router-view v-if="get_siteInfo.ID"/> -->
    <HomeComponents v-if="get_siteInfo.ID"></HomeComponents>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import UrlConfig from '@/api/base-url.js';
import axios from 'axios';
import HomeComponents from './home'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  components:{
    HomeComponents
  },
  watch: {
  },
  computed: {
      ...mapGetters(["get_siteInfo"])
  },

  created () {
    this.setRem()
    window.addEventListener('resize', () => {
      this.setRem()
    })
  },
  mounted () {
    this.getSiteInfo();
  },
  methods: {

    setRem () {
      var ww = document.documentElement.clientWidth
      document.documentElement.style.fontSize = ww / 3.75 + 'px'
      let Mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      let cw = document.body.clientWidth
      if (Mobile || cw <= 750) {
        document.body.classList.remove('pc-app')
        document.body.classList.add('m-app')
        this.isMobile = true
      } else {
        document.body.classList.remove('m-app')
        document.body.classList.add('pc-app')
        this.isMobile = false
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    },
    getQueryObj(){
      const search = window.location.search; // 获取当前URL的查询字符串
      const group = search.substring(1).split('&'); // 去除问号并拆分为数组
      const targetObject = group.reduce((obj, item) => {
        const [key, value] = item.split('=');
        obj[key] = decodeURIComponent(value); // URL解码处理
        return obj;
      }, {});
      return targetObject
    },
    async getSiteInfo(){
      let apiUrl=UrlConfig.baseUrl+"/request/site/info/get";
      let currencyUrl=UrlConfig.baseUrl+"/request/config/sitecurrency";
      let gsInfo = await axios.post(apiUrl);
      let gCurrency = await axios.post(currencyUrl);
      // let query = this.$route.query;
      let query = this.getQueryObj();
      console.log(query)
      if (gsInfo.data&&gsInfo.data.success==1&&gCurrency.data&&gCurrency.data.success==1) {
        let siteInfo = gsInfo.data.info;
        this.$store.commit('SET_siteInfo',siteInfo);
        let currencyActive=""
        if(query&&(query.Currency || query.currency)){
          if(query.Currency){
            currencyActive=this.convertToUpperCase(query.Currency);
          }
          if(query.currency){
            currencyActive=this.convertToUpperCase(query.currency);
          }
        }
        let currencyList=gCurrency.data.info.list;
        currencyList = this.currencySort(currencyList,currencyActive);//重置币种排序、
        this.$store.commit('SET_currencyList',currencyList);
      }
    },
    currencySort(currencyList,currencyActive){
      let currency="";
      if(currencyActive&&currencyActive!='undefined'){
        currency=currencyActive
      } else{
        currency=currencyList[0].Currency
      }
      let list1=currencyList.filter((item)=>{
        return item.Currency==currency;
      })
      let list2=currencyList.filter((item)=>{
        return item.Currency!=currency;
      })
      let list=[...list1,...list2];
      return list;
    },

    // 全部转大写
    convertToUpperCase(text){
      let res = '';
      for (let i = 0; i < text.length; i++) {
        if (text[i] >= 'a' && text[i] <= 'z') {
          res += text[i].toUpperCase();
        } else {
          res += text[i];
        }
      }
      return res;
    },


  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue